import React, { FC } from 'react';
import { Image } from '~/components/image';
import cls from 'classnames';

import './style.scss';

type AvatarProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const Avatar: FC<AvatarProps> = (props) => {
  const { className } = props;

  return <Image {...props} className={cls('lemon8-avatar', className)} />;
};
